import { withErrorBoundary } from 'app/components/error-boundary';
import { images } from 'app/design/images';
import FancySeparator from 'app/design/images/fancy-separator';
import Thanks from 'app/design/images/quick-offers';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';

import { useDeviceHeight, useDeviceWidth } from 'app/hooks/use-device-size';
import { ListingType } from 'app/types/listing';
import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle } from 'app/utils/web-helpers';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const ThanksWebScreenComponent: NavigationScreen<'thanks'> = ({ navigation, route }) => {
  const setPageTitle = usePageTitle('thanks');
  useEffect(() => setPageTitle('title'), [setPageTitle]);

  const { t } = useTranslation('thanks');
  const deviceHeight = useDeviceHeight();
  const w = useDeviceWidth();

  const userNowContributor = route.params.userNowContributor;

  const onGoToMain = () => {
    navigation.getParent()?.reset({ routes: [{ name: 'main' }] });
  };

  const onViewListingPressed = () => {
    navigation.getParent()?.navigate('management', {
      screen: 'my-listings',
      params: { type: ListingType.offer },
      initial: false,
    });
  };

  return (
    <Row backgroundColor="surface.default" flex={1}>
      <Column flex={1} justifyContent="center">
        <View
          style={{
            marginRight: theme.spacing['spacing.general.x12'] + 20,
            marginLeft: theme.spacing['spacing.general.x12'] + 20,
          }}
        >
          <ScrollView
            showsVerticalScrollIndicator
            contentContainerStyle={{
              paddingBottom: theme.spacing['spacing.general.x8'],
              maxHeight: deviceHeight * 0.7,
            }}
          >
            {userNowContributor ? (
              <Column
                alignItems="center"
                gap="spacing.general.x4"
                paddingHorizontal="spacing.general.x8"
                paddingTop="spacing.general.x8"
              >
                <FancySeparator width={w - 2 * 40} />
                <Row alignItems="center" style={{ marginHorizontal: 40 }}>
                  <Text
                    style={{
                      fontSize: 18,
                      textAlign: 'center',
                      width: w - 2 * 40,
                      paddingHorizontal: 5,
                    }}
                    variant="bodyBase"
                  >
                    <Trans
                      components={{ strong: <Text fontWeight="700" /> }}
                      i18nKey="userNowContributorText"
                      ns="free-sub"
                    />
                  </Text>
                </Row>

                <FancySeparator width={w - 2 * 40} />
              </Column>
            ) : null}

            <View style={{ alignItems: 'center' }}>
              <Thanks />
            </View>

            <Text
              fontSize={18}
              lineHeight={22}
              marginHorizontal="spacing.general.x8"
              marginTop="spacing.general.x8"
              textAlign="center"
            >
              <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey="bodyText" ns="quick-new-thanks" />
            </Text>
          </ScrollView>
          <Row>
            <Button flex={1} marginHorizontal="spacing.general.x4" onPress={onGoToMain} variant="whiteWithBorder">
              <Text color="text.primary" textAlign="center">
                {t('buttonBackText')}
              </Text>
            </Button>

            <Button flex={1} marginHorizontal="spacing.general.x4" onPress={onViewListingPressed} variant="primary">
              <Text color="surface.default" textAlign="center">
                {t('buttonListingsText')}
              </Text>
            </Button>
          </Row>
        </View>
      </Column>
      <Column flex={1}>
        <PCImage flex={1} cachePolicy="memory-disk" source={images.web.thank_you} />
      </Column>
    </Row>
  );
};

export const ThanksWebScreen: NavigationScreen<'thanks'> = withErrorBoundary(ThanksWebScreenComponent);
